import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeEsCl from '@angular/common/locales/es-CL';

// Polyfill para Promise.try (requerido por pdfjs-dist v5+)
if (typeof (Promise as any).try === 'undefined') {
  (Promise as any).try = function <T>(fn: () => T | PromiseLike<T>): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      try {
        resolve(fn());
      } catch (e) {
        reject(e);
      }
    });
  };
}

registerLocaleData(localeEsCl);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
